/* Leitura, compressão e visualização dos arquivos anexados ao caso. */
import { esc, kb, lerURL, carregarImg } from "../util.js";
import { sb, BUCKET } from "../supabase.js";

export const LIMITE=8*1024*1024;
export async function preparar(f){
  if(!String(f.type).startsWith("image/")){
    if(f.size>LIMITE) throw new Error(`"${f.name}" tem ${kb(f.size)}. O limite por arquivo é 8 MB.`);
    return {blob:f,nome:f.name,tipo:f.type||"application/octet-stream",preview:null};
  }
  try{
    const img=await carregarImg(await lerURL(f));
    const max=1800, k=Math.min(1,max/Math.max(img.width,img.height));
    const cv=document.createElement("canvas");
    cv.width=Math.round(img.width*k); cv.height=Math.round(img.height*k);
    cv.getContext("2d").drawImage(img,0,0,cv.width,cv.height);
    const blob=await new Promise(r=>cv.toBlob(r,"image/jpeg",.78));
    return {blob,nome:(f.name||"foto").replace(/\.[^.]+$/,"")+".jpg",tipo:"image/jpeg",preview:cv.toDataURL("image/jpeg",.4)};
  }catch(e){
    if(f.size>LIMITE) throw new Error(`"${f.name}" tem ${kb(f.size)}. O limite por arquivo é 8 MB.`);
    return {blob:f,nome:f.name,tipo:f.type,preview:null};
  }
}

export async function urlAssinada(caminho){
  const {data,error}=await sb.storage.from(BUCKET).createSignedUrl(caminho,3600);
  return error?null:data.signedUrl;
}
export function abrirVisualizador(nome,tipo,url,baixavel){
  const v=document.createElement("div"); v.className="viewer";
  v.innerHTML=`<div class="viewer-bar"><span class="nm">${esc(nome)}</span>
    ${baixavel?`<a class="mini" href="${url}" download="${esc(nome)}" target="_blank" rel="noopener" style="text-decoration:none">Baixar</a>`:""}
    <button class="mini" data-fechar>Fechar</button></div>
    <div class="viewer-body">${String(tipo).startsWith("image/")?`<img src="${url}" alt="${esc(nome)}">`:`<iframe src="${url}" title="${esc(nome)}"></iframe>`}</div>`;
  v.addEventListener("click",e=>{ if(e.target.hasAttribute("data-fechar")||e.target===v) v.remove(); });
  document.body.appendChild(v);
}
